import { render, staticRenderFns } from "./TermsIndex.vue?vue&type=template&id=88b06df4&scoped=true"
import script from "./TermsIndex.vue?vue&type=script&lang=js"
export * from "./TermsIndex.vue?vue&type=script&lang=js"
import style0 from "./TermsIndex.vue?vue&type=style&index=0&id=88b06df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b06df4",
  null
  
)

export default component.exports